import { type LinkComponentProps, Link as TanStackLink } from "@tanstack/react-router";
import type { ReactNode } from "react";

type ExternalLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  to?: never;
  params?: never;
  search?: never;
  children?: ReactNode;
};

type InternalLinkProps = LinkComponentProps<"a"> & {
  href?: never;
};

export type AppLinkProps = InternalLinkProps | ExternalLinkProps;

function isExternalHref(href: string): boolean {
  return (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("//") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  );
}

export default function Link(props: AppLinkProps) {
  if ("href" in props && props.href != null) {
    const { href, children, ...rest } = props;
    if (!isExternalHref(href)) {
      throw new Error(
        `Internal app links must use TanStack Router \`to\`/\`params\`/\`search\`, not href="${href}"`
      );
    }
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }

  return <TanStackLink {...props} />;
}
